<template>
    <main id="content">
        <div class="row">
           <div class="col xl3 s12">
                <div class="card  small" id="tacometroOcupacion">
                      <div v-if="loadingResults" class="progress">
                      <div class="indeterminate"></div>
                  </div>
                </div>
            </div>
            <div class="col xl6 s12">
                <div class="card small " id="detalleOcupacion">
                     <div v-if="loadingResults" class="progress">
                      <div class="indeterminate"></div>
                  </div>
                </div>
            </div>


            <div class="col xl3 s12">
                <div class="card lime lighten-1 small center">
                  <div v-if="loadingResultsInvoices" class="progress">
                      <div class="indeterminate"></div>
                  </div>
                     <br/>
                     <br/>
                     Facturación del mes:<br/>
                     <span class="analytic-number" >{{totalFacturacionStr}}</span>
                     <br>
                     Pagado:<br/>
                     <span class="analytic-number" >{{totalFacturacionPagadaStr}}</span>


                </div>
            </div>
        </div>
        <div class="row">
            <div class="col xl12 s12">
                <div class="card" id="detalleOcupacionStacked">
                    <div id="container" style="height: 400px"></div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import * as Highcharts from 'highcharts';

const moment = require('moment');
require('highcharts/highcharts-more')(Highcharts);

import {indicadorFacturacion} from '../../controllers/comercial/facturacion.js';
import {restService} from '../../controllers/rest.js';
const restServiceInstance = new restService();
const facturacionInstance = new indicadorFacturacion();
export default {
  mounted() {
    this.getVehicles();
    const vue = this;
    this.loadingResultsInvoices = true;
    facturacionInstance
      .getInvoicesData()
      .then((invoices) => {
        facturacionInstance
          .calculateInvoicesDetailedAmmount(
            'all',
            moment(moment().format('YYYY-MM-01')).valueOf(),
            moment().valueOf(),
          )
          .then((resultObj) => {
            vue.loadingResultsInvoices = false;
            console.log('RESULTOBJ', resultObj);
            console.log('HASHMAP TOTALS', resultObj.hashMapCountResult);
            if (!resultObj.hashMapCountResult.open) { resultObj.hashMapCountResult.open = 0; }
            if (!resultObj.hashMapCountResult.paid) { resultObj.hashMapCountResult.paid = 0; }
            vue.totalFacturacionStr =
              `$${
                (
                  resultObj.hashMapCountResult.open +
                resultObj.hashMapCountResult.paid
                ).formatMoney(2)}`;
            vue.totalFacturacionPagadaStr =
              `$${resultObj.hashMapCountResult.paid.formatMoney(2)}`;
          });
      })
      .catch((err) => {
        console.log(err, 'ERROR FETCHING INVOICES');
      });
  },
  data() {
    return {
      Highcharts: null,
      vehicles: {},
      loadingResults: false,
      loadingResultsInvoices: false,
      vehiclesInOperationUnit: [],
      allVehicles: [],
      allStock: [],
      vehicleCounter: {},
      totalFacturacionStr: '',
      totalFacturacionPagadaStr: '',
    };
  },
  methods: {
    getVehiclesInOperationUnit() {
      const priorities = {
        rentado: 0,
        rentado_servicio: 1,
        entrega: 2,
        recoger: 3,
        disponible: 4,
        servicio_taller: 5,
      };
      const colors = {
        rentado: '#1b5e20',
        rentado_servicio: '#fdd835',
        entrega: '#4c8c4a',
        recoger: '#212121',
        disponible: '#0277bd',
        servicio_taller: '#b71c1c',
      };
      this.allStock.forEach((vehicle) => {
        if (vehicle && vehicle.product_id && vehicle.almacen_id) {
          this.vehiclesInOperationUnit.push(vehicle);
          if (!this.vehicleCounter[vehicle.estado]) { this.vehicleCounter[vehicle.estado] = 0; }
          this.vehicleCounter[vehicle.estado]++;
        }
      });
      this.loadingResults = false;
      const rentados =
        this.vehicleCounter.rentado +
        this.vehicleCounter.rentado_servicio +
        this.vehicleCounter.entrega;
      const percentage =
        this.vehiclesInOperationUnit.length == 0
          ? 0
          : (rentados * 100) / this.vehiclesInOperationUnit.length;
      console.log('PERCENTAGE: ', percentage);
      this.createChartDisponibilidad(
        parseFloat(percentage.toFixed(2)),
        this.vehiclesInOperationUnit.length,
        rentados,
      );
      const values = Object.keys(this.vehicleCounter);
      let dataArr = [];
      values.forEach((value) => {
        dataArr.push({
          name: value,
          y: this.vehicleCounter[value],
          priority: priorities[value],
          color: colors[value],
        });
      });
      dataArr.sort((a, b) => {
        if (a.priority > b.priority) return 1;
        if (a.priority == b.priority) return 0;
        return -1;
      });
      console.log('ARR', dataArr);
      this.createChartDetalleDisponibilidad(dataArr);
      dataArr = [];
      const detalleOcupacion = {
        rentado: 0,
        disponible: 0,
        servicio: 0,
        recoger: 0,
      };
      values.forEach((value) => {
        const serie = {
          name: value,
          priority: priorities[value],
          color: colors[value],
        };
        if (
          serie.name == 'rentado' ||
          serie.name == 'rentado_servicio' ||
          serie.name == 'entrega'
        ) {
          serie.data = [this.vehicleCounter[value], 0, 0, 0];
          detalleOcupacion.rentado += this.vehicleCounter[value];
        } else if (serie.name == 'disponible') {
          serie.data = [0, this.vehicleCounter[value], 0, 0];
          detalleOcupacion.disponible += this.vehicleCounter[value];
        } else if (serie.name == 'servicio_taller') {
          serie.data = [0, 0, this.vehicleCounter[value], 0];
          detalleOcupacion.servicio += this.vehicleCounter[value];
        } else if (serie.name == 'recoger') {
          serie.data = [0, 0, 0, this.vehicleCounter[value]];
          detalleOcupacion.recoger += this.vehicleCounter[value];
        }
        dataArr.push(serie);
      });
      dataArr.sort((a, b) => {
        if (a.priority < b.priority) return 1;
        if (a.priority == b.priority) return 0;
        return -1;
      });
      console.log('DATA ARR-', dataArr);

      this.createChartDetalleDisponibilidadStacked(dataArr, detalleOcupacion);
    },
    getVehicles() {
      this.vehicleCounter = {};
      this.loadingResults = true;
      this.vehiclesInOperationUnit = [];
      this.vehicles = {};
      this.rows = [];
      const vueInstance = this;
      if (vueInstance.allVehicles.length > 0) {
        vueInstance.getVehiclesInOperationUnit();
      } else {
        restServiceInstance
          .getStockLot()
          .then((stock) => {
            vueInstance.allStock = stock;
            vueInstance.getVehiclesInOperationUnit();
            vueInstance.loadingResults = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    createChartDetalleDisponibilidadStacked(dataArr, detalleOcupacion) {
      console.log(dataArr, 'STACKED');
      Highcharts.chart('detalleOcupacionStacked', {
        chart: {
          type: 'bar',
        },
        title: {
          text: 'Ocupación',
        },
        xAxis: {
          categories: [
            `Ocupación <br/>${detalleOcupacion.rentado}`,
            `Disponible <br/>${detalleOcupacion.disponible}`,
            `Servicio <br/>${detalleOcupacion.servicio}`,
            `Recoger <br/>${detalleOcupacion.recoger}`,
          ],
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Total de unidades',
          },
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: 'normal',
          },
        },
        series: dataArr,
      });
    },
    createChartDetalleDisponibilidad(dataArr) {
      Highcharts.chart('detalleOcupacion', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
        },
        title: {
          text: 'Detalle Ocupación',
          align: 'center',
          verticalAlign: 'middle',
          y: 40,
        },
        tooltip: {
          pointFormat:
            '{series.name}: <b>{point.percentage:.1f}% -  {point.y}</b>',
        },
        plotOptions: {
          pie: {

            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
          },
        },
        series: [
          {
            type: 'pie',
            name: '% de Ocupación',
            innerSize: '50%',
            data: dataArr,
          },
        ],
      });
    },
    createChartDisponibilidad(ocupacion, equipos, ocupados) {
      console.log('Pintara chart,', ocupacion);
      Highcharts.chart('tacometroOcupacion', {
        chart: {
          type: 'gauge',
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0,
          plotShadow: false,
        },
        title: {
          text: 'Ocupación',
        },
        pane: {
          startAngle: -150,
          endAngle: 150,
          background: [
            {
              backgroundColor: {
                linearGradient: {
                  x1: 0, y1: 0, x2: 0, y2: 1,
                },
                stops: [[0, '#FFF'], [1, '#333']],
              },
              borderWidth: 0,
              outerRadius: '109%',
            },
            {
              backgroundColor: {
                linearGradient: {
                  x1: 0, y1: 0, x2: 0, y2: 1,
                },
                stops: [[0, '#333'], [1, '#FFF']],
              },
              borderWidth: 1,
              outerRadius: '107%',
            },
            {
              // default background
            },
            {
              backgroundColor: '#DDD',
              borderWidth: 0,
              outerRadius: '105%',
              innerRadius: '103%',
            },
          ],
        },

        // the value axis
        yAxis: {
          min: 0,
          max: 100,

          minorTickInterval: 'auto',
          minorTickWidth: 1,
          minorTickLength: 10,
          minorTickPosition: 'inside',
          minorTickColor: '#666',

          tickPixelInterval: 30,
          tickWidth: 2,
          tickPosition: 'inside',
          tickLength: 10,
          tickColor: '#666',
          labels: {
            step: 2,
            rotation: 'auto',
          },
          title: {
            text: `${ocupados}/${equipos}`,
          },
          plotBands: [
            {
              from: 0,
              to: 20,
              color: '#DF5353',
            },
            {
              from: 21,
              to: 75,
              color: '#DDDF0D',
            },
            {
              from: 76,
              to: 85,
              color: '#55BF3B',
            },
            {
              from: 86,
              to: 100,
              color: '#DF5353',
            },
          ],
        },
        series: [
          {
            name: 'Ocupación',
            data: [{ y: ocupacion, z: equipos }],
            tooltip: {
              valueSuffix: ` % <br/> ${ocupados}/${equipos}`,
            },
          },
        ],
      });
    },
  },
};
</script>
<style scoped>
.analytic-number {
  font-size: 2rem;
  width: 100%;
  text-align: center;
}
</style>
